import { Fragment, useCallback, useEffect, useRef, useState } from 'react';

import styles from '../../styles/modules/game/Game.module.scss';

import GameBox from './GameBox';

import { getRandomNumber } from '../../utils/common';

const GameFeeds = () => {
	return (
		<div className={styles.feeds}>
			{Array.from({ length: 3 }, (_, idx) => (
				<GameFeed key={idx} idx={idx + 1} />
			))}
		</div>
	);
};

const GameFeed = ({ idx }) => {
	const [boxes, setBoxes] = useState([]);

	const intervalRef = useRef(null);
	const firstTimeoutRef = useRef(null);
	const boxIdRef = useRef(0);

	const removeBox = useCallback((id) => {
		setBoxes((prev) => prev.filter((box) => box.id !== id));
	}, []);

	const addBox = useCallback(() => {
		const newBoxId = `box-${idx}-${boxIdRef.current++}`;

		setBoxes((prevBoxes) => [...prevBoxes, { id: newBoxId }]);
	}, [idx]);

	const startAddingBoxes = useCallback(() => {
		if (intervalRef.current != null || firstTimeoutRef.current != null) return;

		const firstDelay = getRandomNumber(500, 2500);

		firstTimeoutRef.current = window.setTimeout(() => {
			firstTimeoutRef.current = null;

			addBox();

			const delay = getRandomNumber(3000, 7000);

			intervalRef.current = window.setInterval(addBox, delay);
		}, firstDelay);
	}, [addBox]);

	const stopAddingBoxes = useCallback(() => {
		if (firstTimeoutRef.current != null) {
			clearTimeout(firstTimeoutRef.current);
			firstTimeoutRef.current = null;
		}

		if (intervalRef.current != null) {
			clearInterval(intervalRef.current);
			intervalRef.current = null;
		}
	}, []);

	useEffect(() => {
		startAddingBoxes();

		const handleVisibilityChange = () => {
			if (document.visibilityState === 'hidden') {
				stopAddingBoxes();
			} else {
				startAddingBoxes();
			}
		};

		document.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			stopAddingBoxes();
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, [startAddingBoxes, stopAddingBoxes]);

	return (
		<div className={styles.feed}>
			<div className={styles.boxes}>
				{boxes.map(({ id }) => (
					<Fragment key={id}>
						<GameBox id={id} feedIdx={idx} onRemoveBox={removeBox} />
					</Fragment>
				))}
			</div>
		</div>
	);
};

export default GameFeeds;
